import gql from 'graphql-tag';

import { Query } from 'core';

const CONTRIBUTIONS_SIDEBAR = gql`
  query ContributionsSidebar(
    $projectId: ID
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $path: String
  ) {
    project(id: $projectId) {
      id
      contributions(
        first: $batchSize
        after: $cursor
        sortBy: $sortBy
        path: $path
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            title
            description
            status
            version
            zipArchiveUrl
            creatorProfile {
              id
              username
              imageFallbackChar
              avatar {
                id
                path
                url
              }
            }
            dateCreated
            lastUpdated
            commenters {
              id
              username
              avatar {
                id
                path
              }
            }
            content {
              id
              whitelabel
            }
            files(basepath: $path) {
              id
              filename
              repoRevision
              file {
                id
                filename
                gitHash
              }
            }
          }
        }
      }
      isRestricted
    }
  }
`;

export class ContributionsSidebarQuery extends Query {
  static conf = {
    GQL: CONTRIBUTIONS_SIDEBAR,
    resultPath: 'project.contributions',
  };
}
